import { render } from "./ShowMenu.vue?vue&type=template&id=ed83cbb0&scoped=true"
import script from "./ShowMenu.vue?vue&type=script&lang=js"
export * from "./ShowMenu.vue?vue&type=script&lang=js"

import "./ShowMenu.vue?vue&type=style&index=0&id=ed83cbb0&lang=scss&scoped=true"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed83cbb0"]])

export default __exports__